/**
 * Shared react-select styles — matches the Fantasy Academy dark theme
 * (black bg, sharp corners, monospace, fa-yellow accent).
 */
export const selectStyles = {
    control: (base, state) => ({
        ...base,
        backgroundColor: "#000",
        borderColor: state.isFocused ? "#FFF3C2" : "rgba(255,255,255,0.1)",
        borderRadius: 0,
        minHeight: 36,
        boxShadow: "none",
        fontFamily: "IBM Plex Mono, monospace",
        fontSize: 12,
        "&:hover": { borderColor: "rgba(255,255,255,0.3)" },
    }),
    menu: (base) => ({
        ...base,
        backgroundColor: "#121212",
        border: "1px solid rgba(255,255,255,0.1)",
        borderRadius: 0,
        zIndex: 50,
    }),
    option: (base, state) => ({
        ...base,
        backgroundColor: state.isFocused ? "rgba(232,248,32,0.1)" : "transparent",
        color: state.isSelected ? "#FFF3C2" : "#fff",
        fontFamily: "IBM Plex Mono, monospace",
        fontSize: 12,
        textTransform: "uppercase",
        letterSpacing: "0.05em",
        cursor: "pointer",
    }),
    multiValue: (base) => ({
        ...base,
        backgroundColor: "rgba(232,248,32,0.1)",
        border: "1px solid rgba(232,248,32,0.4)",
        borderRadius: 0,
    }),
    multiValueLabel: (base) => ({
        ...base,
        color: "#FFF3C2",
        fontFamily: "IBM Plex Mono, monospace",
        fontSize: 10,
        textTransform: "uppercase",
        letterSpacing: "0.05em",
    }),
    multiValueRemove: (base) => ({
        ...base,
        color: "#FFF3C2",
        "&:hover": { backgroundColor: "#FFF3C2", color: "#000" },
    }),
    placeholder: (base) => ({ ...base, color: "rgba(255,255,255,0.3)" }),
    input: (base) => ({ ...base, color: "#fff" }),
    singleValue: (base) => ({ ...base, color: "#fff" }),
    dropdownIndicator: (base) => ({ ...base, color: "rgba(255,255,255,0.5)" }),
    indicatorSeparator: () => ({ display: "none" }),
};
